import { render, staticRenderFns } from "./FormWrap.vue?vue&type=template&id=0cbebc4a&"
import script from "./FormWrap.vue?vue&type=script&lang=js&"
export * from "./FormWrap.vue?vue&type=script&lang=js&"
import style0 from "./FormWrap.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports